import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

export const AuthLayout = (): ReactNode => {
  return (
    <div className="flex min-h-screen bg-gray-950 text-white">
      <div className="flex-1 px-4">
        <div className="flex h-full flex-col">
          <main className="grid flex-1 place-items-center">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};
